<script>
import { Line, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";
import { wsInfo } from "../base";


export default {
  extends: Line,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              if (tooltipItem.datasetIndex === 0) {
                return value + " RATE_LIMIT_HIT";
              } else if (tooltipItem.datasetIndex === 1) {
                return value + " GUILD_DELETE";
              } else if (tooltipItem.datasetIndex === 2) {
                return value + " GUILD_CREATE";
              } else {
                return value;
              }
            },
          },
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await wsInfo()
      .then((response) => {
        // console.log(response);
        //map all date inside response.data.stats_daily, and filter empty arrays.
        let dateData = response.map((item) => {
          return item.date;
        });

        let guildCreate = response.map((item) => {
          return item.data.guildCreate;
        });

        let guildDelete = response.map((item) => {
          return item.data.guildDelete;
        });


        let rateLimit = response.map((item) => {
          return item.data.rateLimit;
        });

        // console.log(dateData, guildCreate, guildDelete, messageCreate, interactionCreate, rateLimit);

        const color1 = getRandomColor();
        const color2 = getRandomColor();
        const color5 = getRandomColor();

        const colorx = getRandomColor();
        const colory = getRandomColor();
        const colorz = getRandomColor();
        

        this.chartData = {
          labels: dateData,
          datasets: [
            {
              label: "RATE_LIMIT_HIT",
              backgroundColor: color5,
              //pointBackgroundColor: color5,
              borderWidth: 4,
              pointBorderColor: colorx,
              data: rateLimit,
            },
            {
              label: "GUILD_DELETE",
              backgroundColor: color2,
              //pointBackgroundColor: color2,
              borderWidth: 4,
              pointBorderColor: colory,
              data: guildDelete,
            },
            {
              label: "GUILD_CREATE",
              backgroundColor: color1,
              //pointBackgroundColor: color1,
              borderWidth: 4,
              pointBorderColor: colorz,
              data: guildCreate,
            },
            
           
          ],
        };

        this.chartOptions = {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: true,
                },
              },
            ],
          },
          legend: {
            display: true,
          },
          responsive: true,
          maintainAspectRatio: false,
        };
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>
